/**
 * Phase 7b — Co-pilot tab on /cases/:id.
 *
 * Read-only for Compliance, full read+write for HR. The panel itself is
 * mounted regardless of role; child components disable Apply/Dismiss
 * buttons when the user is read-only. Manager and Leadership never see
 * the tab (gated upstream in CaseDetail.jsx).
 */
import React from "react";
import { Sparkles } from "lucide-react";
import NextActionsPanel from "./NextActionsPanel";
import SimilarCasesPanel from "./SimilarCasesPanel";
import OutcomePanel from "./OutcomePanel";
import RedactionPanel from "./RedactionPanel";

const COPILOT_DISCLAIMER =
  "AI-generated. Review before action. Every Co-pilot interaction is audit-logged.";

export default function CopilotPanel({ caseId, currentCase, isReadOnly, onCaseRefreshed }) {
  return (
    <div className="space-y-6" data-testid="copilot-panel">
      <div
        className="brand-card flex flex-col gap-2 border border-brand-tealMist/60 bg-gradient-to-br from-white via-white to-brand-tealMist/30 px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
        data-testid="copilot-header"
      >
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-brand-teal/10 p-2 text-brand-teal">
            <Sparkles className="h-5 w-5" />
          </div>
          <div>
            <p className="text-sm font-semibold text-[color:var(--page-fg)]">
              Case Co-pilot
            </p>
            <p className="text-xs text-[color:var(--page-fg-muted)]">{COPILOT_DISCLAIMER}</p>
          </div>
        </div>
        {isReadOnly && (
          <span
            className="self-start rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
            data-testid="copilot-readonly-pill"
            style={{
              backgroundColor: "rgba(232,203,142,0.18)",
              color: "#A47A2D",
            }}
          >
            Read-only · Compliance
          </span>
        )}
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <NextActionsPanel
          caseId={caseId}
          isReadOnly={isReadOnly}
          onCaseRefreshed={onCaseRefreshed}
        />
        <OutcomePanel
          caseId={caseId}
          currentCase={currentCase}
          isReadOnly={isReadOnly}
          onCaseRefreshed={onCaseRefreshed}
        />
      </div>

      <SimilarCasesPanel caseId={caseId} />

      <RedactionPanel
        caseId={caseId}
        isReadOnly={isReadOnly}
        onCaseRefreshed={onCaseRefreshed}
      />
    </div>
  );
}
